import React from 'react';
import Wetter from '../components/Wetter';
import MyOrtMap from '../components/MyOrtMap';
import logo from '../assets/logo.png'; // Pfad ggf. anpassen
import { Link } from 'react-router-dom';
import './home.css'; // gleiche Styles wie bei Home verwenden


function WetterKlausenLeopoldsdorf() {
  return (
    <div className="home-container">
      <div className="home-diagramm">
        <div className='wetter-container'><h1 >WETTER</h1></div>
        
        <Wetter ort="klausen-Leopoldsdorf" />
      </div>
    </div>
  );
}

export default WetterKlausenLeopoldsdorf;
